module.exports = __webpack_public_path__ + "static/img/app_store.0c31a7f6.webp";